export default "__VITE_ASSET__e312ddba__"